import { FC, memo } from 'react';
import { FWDPriceProps } from './FWDPrice.types';
import styles from './FWDPrice.module.scss';
import classNames from 'classnames';
import LoadingDot from '../LoadingDot';

const FWDPrice = memo((props: FWDPriceProps) => {
  const [IntPrice, decimalPrice] = Number(props?.price || 0)
    ?.toFixed(2)
    .toString()
    .split('.');
  const { unit, isLoading, isDisable = false } = props;

  return (
    <div className={classNames(styles.price_grid, isDisable && styles.disable)}>
      <div className={styles.black_font}>HK$</div>
      {isLoading && <LoadingDot />}
      {!!props.price && !isDisable && !isLoading && (
        <>
          <div className={styles.orange_big_price}>{Number(IntPrice).toLocaleString()}</div>
          <div className={styles.orange_small_price}>.{decimalPrice || '00'}</div>
        </>
      )}
      {(!props.price || isDisable) && !isLoading && <div className={styles.countup}>--</div>}

      <div className={styles.price_unit}>/{unit}</div>
    </div>
  );
});
export default FWDPrice;
